import { format, parseISO } from "date-fns";

import { DataTable, ExtendedColumnDef } from "@/components/Datatable";
import { IStoreExchange } from "src/@types/store-exchange";

import {
  CURRENCY_LOCALE,
  CURRENCY_OPTIONS,
  DISPLAY_DATE_FORMAT,
  EMPTY_CELL,
} from "../types";

interface StoreExchangeTableProps {
  readonly exchanges: IStoreExchange[];
  readonly isLoading: boolean;
  readonly emptyMessage: string;
}

const text = (value: string | number | null): string =>
  value === null || value === "" ? EMPTY_CELL : String(value);

const date = (value: string | null): string =>
  value === null ? EMPTY_CELL : format(parseISO(value), DISPLAY_DATE_FORMAT);

const currency = (value: number): string =>
  value.toLocaleString(CURRENCY_LOCALE, CURRENCY_OPTIONS);

const columns: ExtendedColumnDef<IStoreExchange>[] = [
  {
    accessorKey: "elaborationDate",
    header: "Elaboração",
    cell: ({ row }) =>
      format(parseISO(row.original.elaborationDate), DISPLAY_DATE_FORMAT),
  },
  {
    accessorKey: "movementDate",
    header: "Movimento",
    cell: ({ row }) => date(row.original.movementDate),
  },
  {
    accessorKey: "movementTime",
    header: "Hora",
    cell: ({ row }) => text(row.original.movementTime),
  },
  { accessorKey: "storeCode", header: "Loja" },
  { accessorKey: "controlNumber", header: "Nº Controle" },
  {
    accessorKey: "operator",
    header: "Operador",
    cell: ({ row }) => text(row.original.operator),
  },
  {
    accessorKey: "customerDocument",
    header: "CPF do Cliente",
    cell: ({ row }) => (
      <span className="whitespace-nowrap">
        {text(row.original.customerDocument)}
      </span>
    ),
  },
  {
    accessorKey: "customerName",
    header: "Nome do Cliente",
    cell: ({ row }) => text(row.original.customerName),
  },
  {
    accessorKey: "totalAmount",
    header: "Total",
    cell: ({ row }) => currency(row.original.totalAmount),
  },
  { accessorKey: "statusLabel", header: "Situação" },
];

export function StoreExchangeTable({
  exchanges,
  isLoading,
  emptyMessage,
}: StoreExchangeTableProps) {
  return (
    <div className="mt-4 overflow-x-auto">
      <DataTable
        columns={columns}
        data={exchanges}
        isLoading={isLoading}
        emptyMessage={emptyMessage}
      />
    </div>
  );
}
